import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import "new_components/Builders/Builders.scss";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import axios from "axios";
import ComingSoon from "new_assets/new_images/Builders/coming_soon1.png";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import PreLoad from "new_components/PreLoad/PreLoad";
import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
const Builders = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <BuildersBanner />
      <BuildingStrategy />
      <DualBannerBuildersRow />

      <OngoingConstructions />

      <CompletedConstructions />
      <HomeBottomBanner />
      {/* <QuoteSection /> */}
    </div>
  );
};

const OngoingConstructions = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(apiUrls.propertiesOngoingInv);
        if (response.data.status === "success") {
          setProperties(response.data.data);
        } else {
          setError("Failed to fetch properties.");
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
      }
    };

    fetchProperties();
  }, []);

  const totalPages = Math.ceil(properties.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProperties = properties.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <section className="completed-projects">
      <section className="flat-section pb-0">
        <div className="container py-5 bg-primary-new">
          <div className=" box-title wow fadeInUp closedInv">
            <h3 className="title text-uppercase">Ongoing construction</h3>
          </div>
          <div>
            {error ? (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            ) : currentProperties.length > 0 ? (
              currentProperties.map((property) => (
                <div key={property.id} className="row mb-5 closedprop bg-white">
                  <div className="buildercompletedprojectshero col-12 col-md-4 col-xl-2 text-center">
                    <img
                      src={Image_Base_URL + property.image}
                      alt={property.title || "Property Image"}
                      className="project-image"
                    />
                  </div>

                  <div className=" col-12 col-md-8 col-xl-10 p-md-3 pl-lg-4 pb-2">
                    <div className="row  body-2 fw-bold pb-2 pt-1">
                      <div className="col">{property.title}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Sq Ft Under AC:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_under_ac}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Sq Ft Exterior Living:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_exterior_living}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        SqFt Garage:{" "}
                        <span className="fw-bold">{property.sq_ft_garage}</span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Total Property:{" "}
                        <span className="fw-bold">
                          {property.total_property}
                        </span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: property.description,
                        }}
                      />
                    </div>
                    <div className="row pt-1 fw-bold">
                      {property.amenities.map((amenity, index) => (
                        <div
                          key={index}
                          className=" col-12 col-lg-6 col-xl-4 pb-md-2 pb-1"
                        >
                          {amenity}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            )}
          </div>
          {currentProperties.length > 0 && !error && totalPages > 1 && (
            <div className="pagination-controls text-center">
              <button
                className="btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className="btn"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </section>
    </section>
  );
};

const CompletedConstructions = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(apiUrls.propertiesCompleteInv);
        if (response.data.status === "success") {
          setProperties(response.data.data);
        } else {
          setError("Failed to fetch properties.");
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
      }
    };

    fetchProperties();
  }, []);

  const totalPages = Math.ceil(properties.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProperties = properties.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  if (!properties.length && !error) {
    return null;
  }

  return (
    <section className="completed-projects">
      <section className="flat-section pb-0">
        <div className="container py-5 bg-primary-new">
          <div className=" box-title wow fadeInUp closedInv">
            <h3 className="title text-uppercase">Completed construction</h3>
          </div>
          <div>
            {error ? (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            ) : currentProperties.length > 0 ? (
              currentProperties.map((property) => (
                <div key={property.id} className="row mb-5 closedprop bg-white">
                  <div className="buildercompletedprojectshero col-12 col-md-4 col-xl-2 text-center">
                    <img
                      src={Image_Base_URL + property.image}
                      alt={property.title || "Property Image"}
                      className="project-image"
                    />
                  </div>

                  <div className=" col-12 col-md-8 col-xl-10 p-md-3 pl-lg-4 pb-2">
                    <div className="row  body-2 fw-bold pb-2 pt-1">
                      <div className="col">{property.title}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Sq Ft Under AC:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_under_ac}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Sq Ft Exterior Living:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_exterior_living}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        SqFt Garage:{" "}
                        <span className="fw-bold">{property.sq_ft_garage}</span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Total Property:{" "}
                        <span className="fw-bold">
                          {property.total_property}
                        </span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: property.description,
                        }}
                      />
                    </div>
                    <div className="row pt-1 fw-bold">
                      {property.amenities.map((amenity, index) => (
                        <div
                          key={index}
                          className=" col-12 col-lg-6 col-xl-4 pb-md-2 pb-1"
                        >
                          {amenity}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            )}
          </div>
          {currentProperties.length > 0 && !error && totalPages > 1 && (
            <div className="pagination-controls text-center">
              <button
                className="btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className="btn"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </section>
    </section>
  );
};

const BuildersBanner = () => {
  const [bannerData, setBannerData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.builderBanner);
        if (response.data.status === "success") {
          setBannerData(response.data.data[0]);
        } else {
          setError("Failed to fetch data");
        }
      } catch (err) {
        setError("An error occurred while fetching data");
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div className="text-white text-center">{error}</div>;
  }

  if (!bannerData) {
    return <div className="text-white text-center">Loading...</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp buildersbanner mx-md-5 px-1 px-md-5"
          data-wow-delay=".2s"
          style={{
            backgroundImage: `url(${Image_Base_URL}${bannerData.image})`,
          }}
        >
          <div className="col-12 text-center">
            <p className="subtitle text-white body-2 wow fadeInUp">
              {bannerData.title1}
            </p>
            <h3 className="title text-white text-uppercase">
              {bannerData.title2}
            </h3>
          </div>
          <div className="col-12 align-items-left">
            <div
              className="subtitle text-white body-2 wow fadeInUp px-5"
              dangerouslySetInnerHTML={{ __html: bannerData.description }}
            ></div>
            <br />
            <button
              className="tf-btn btn-view primary hover-btn-view ml-5"
              onClick={() => {
                const url = new URL("/contact-us", window.location.origin);
                url.searchParams.set("form", "form2");
                window.location.href = url.toString();
              }}
            >
              Contact us<span className="icon icon-arrow-right2"></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
const BuildingStrategy = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(apiUrls.buildingStrategy)
      .then((response) => {
        if (response.data.status === "success") {
          setData(response.data.data[0]);
        } else {
          setError("Failed to fetch data");
        }
      })
      .catch((err) => {
        setError("An error occurred while fetching data");
      });
  }, []);

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  if (!data) {
    return <div className="text-center">Loading...</div>;
  }

  return (
    <section className="flat-section bg-primary-new">
      <div className="container">
        <div className="box-title text-center wow fadeInUp">
          <h3 className="mt-4 title">{data.title}</h3>
        </div>
        <div
          className="row align-items-center justify-content-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-12 col-md-4 text-center mb-2 build-strategy">
            <img
              src={data.image ? `${Image_Base_URL}${data.image}` : "#"} // Replace "your-image-base-url" with your image base URL
              alt="builder right"
            />
          </div>
          <div className="col-12 col-md-8">
            <div
              className="note body-2 mb-3 fw-bold"
              dangerouslySetInnerHTML={{ __html: data.description }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};
const DualBannerBuildersRow = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.builderCallToAction);
        setData(response.data.data);
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!data) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <section className="row dualbannerbuildersrow">
      {data.map((item) => (
        <div key={item.id} className="col-12 col-md-6 dualbannerbuildersone">
          <h6 className="title text-white">{item.title}</h6>
          <br></br>
          <Link
            to={item.button_link}
            className="tf-btn btn-view primary hover-btn-view ml-5 dualbannerinvonebtn text-black"
          >
            {item.button_text}
            <span className="icon icon-arrow-right2 dualbannerinvonebtnicon"></span>
          </Link>
        </div>
      ))}
      <div
        className="col-12 col-md-6 dualbannerbuilderssecpic"
        style={{
          backgroundImage: `url(${Image_Base_URL}${data[0].image})`,
        }}
      ></div>
    </section>
  );
};
// const QuoteSection = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(apiUrls.bottomBanner);
//         if (
//           response.data.status === "success" &&
//           response.data.data.length > 0
//         ) {
//           setData(response.data.data[0]);
//         } else {
//           throw new Error(
//             "Invalid API response structure or no data available."
//           );
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="text-center">
//         <PreLoad />
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="text-center text-danger">Error: {error}</div>;
//   }

//   return (
//     <section className="flat-section">
//       <div className="container">
//         <div
//           className="row align-items-center justify-content-center wow fadeInUp ldgquote mx-md-5"
//           data-wow-delay=".2s"
//           style={{ backgroundImage: `url(${Image_Base_URL}${data.bg_image})` }}
//         >
//           <div className="col-12 text-center">
//             <h3 className="title text-white">
//               {data?.title || "Title not available"}
//             </h3>
//             <div className="note body-2 text-white pt-2">
//               {data?.footer_text || "Description not available"}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
export default Builders;
